"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGrid = exports.DGDataCell = void 0;
const util_1 = require("@app/util");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const text_1 = require("../text");
require("./index.scss");
const getSafeValue = (value) => {
    return (typeof value === 'object' && (0, util_1.isNull)(value)) ||
        (0, util_1.isUndefined)(value) ||
        (typeof value === 'string' && value.length === 0) ||
        (typeof value === 'number' && Number.isNaN(value))
        ? '-'
        : value;
};
const DGDataCell = ({ value }) => {
    return react_1.default.createElement("div", { className: 'data' }, getSafeValue(value));
};
exports.DGDataCell = DGDataCell;
const DataGrid = ({ columns: _columns, header }) => {
    const dataGridID = react_1.default.useId();
    const columns = react_1.default.useMemo(() => _columns.filter((c) => (0, util_1.isDefined)(c.cells)), [_columns]);
    const columnCount = columns.length;
    const safeColumnCount = Math.max(columnCount, 1);
    const rowCount = react_1.default.useMemo(() => columns.reduce((max, column) => (column?.cells?.length ?? 0) > max ? (column?.cells?.length ?? 0) : max, 0), [columns]);
    const rows = react_1.default.useMemo(() => Array.from({ length: rowCount }, (_, i) => i), [rowCount]);
    return (react_1.default.createElement("div", { className: 'ds-data-grid' },
        (0, util_1.isDefined)(header) && (react_1.default.createElement("div", { className: 'data-grid-header', style: {
                width: `calc(100% / ${safeColumnCount})`,
            } },
            react_1.default.createElement("div", { className: 'data-grid-cell label-cell' }, typeof header.label === 'string' ? (react_1.default.createElement(text_1.Text, { color: text_1.Text.COLORS.DARK_BLUE, weight: text_1.Text.WEIGHTS.BOLD, text: header.label.toUpperCase() })) : (header.label)),
            react_1.default.createElement("div", { className: 'data-grid-cell data-cell' }, getSafeValue(header.value)))),
        react_1.default.createElement("div", { className: 'data-grid-body' }, rows.map((rowIndex) => {
            const rowCells = columns
                .map((column, columnIndex) => ({
                cell: column?.cells?.[rowIndex],
                columnIndex,
            }))
                .filter((item) => (0, util_1.isDefined)(item.cell));
            const firstVisibleColumnIndex = rowCells[0]?.columnIndex ?? 0;
            const lastVisibleColumnIndex = rowCells[rowCells.length - 1]?.columnIndex ?? firstVisibleColumnIndex;
            const occupiedColumnSpan = lastVisibleColumnIndex - firstVisibleColumnIndex + 1;
            const rightEdgeIsGlobalLastColumn = lastVisibleColumnIndex === columnCount - 1;
            const rightEdgeEndsOnThisRow = rightEdgeIsGlobalLastColumn &&
                !(0, util_1.isDefined)(columns?.[lastVisibleColumnIndex]?.cells?.[rowIndex + 1]);
            const hideRowRightBorder = rightEdgeEndsOnThisRow && rowIndex < rowCount - 1;
            return (react_1.default.createElement("div", { key: `data-grid-${dataGridID}-row-${rowIndex}`, className: (0, classnames_1.default)('data-grid-row', {
                    'top-left-radius': (0, util_1.isUndefined)(header) && rowIndex === 0,
                    'top-right-radius': rowIndex === 0 && ((0, util_1.isUndefined)(header) || safeColumnCount > 1),
                    'bottom-left-radius': rowIndex === rowCount - 1,
                    'bottom-right-radius': rowIndex === rowCount - 1,
                    'no-right-border': hideRowRightBorder,
                }), style: {
                    width: `calc(100% * ${occupiedColumnSpan} / ${safeColumnCount})`,
                    marginLeft: `calc(100% * ${firstVisibleColumnIndex} / ${safeColumnCount})`,
                    gridTemplateColumns: `repeat(${occupiedColumnSpan}, minmax(0, 1fr))`,
                } }, rowCells.map(({ cell, columnIndex }) => {
                const isFirstVisible = columnIndex === firstVisibleColumnIndex;
                const isLastVisible = columnIndex === lastVisibleColumnIndex;
                const relativeColumnIndex = columnIndex - firstVisibleColumnIndex;
                const hasCellBelow = (0, util_1.isDefined)(columns?.[columnIndex]?.cells?.[rowIndex + 1]);
                const isColumnEnd = !hasCellBelow;
                const noRightBorder = isLastVisible && !hideRowRightBorder;
                return (react_1.default.createElement("div", { key: `data-grid-${dataGridID}-${rowIndex}-${columnIndex}`, className: (0, classnames_1.default)('data-grid-column', {
                        'top-left-radius': (0, util_1.isUndefined)(header) && rowIndex === 0 && isFirstVisible,
                        'top-right-radius': rowIndex === 0 &&
                            isLastVisible &&
                            ((0, util_1.isUndefined)(header) || safeColumnCount > 1),
                        'bottom-left-radius': isColumnEnd && isFirstVisible,
                        'bottom-right-radius': isColumnEnd && isLastVisible,
                        'column-ended': isColumnEnd,
                        'column-ended-left-edge': isColumnEnd && isFirstVisible,
                    }), style: {
                        gridColumn: `${relativeColumnIndex + 1} / ${relativeColumnIndex + 2}`,
                    } },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('data-grid-cell', 'label-cell', {
                            'no-left-border': isFirstVisible,
                        }) }, typeof cell.label === 'string' ? (react_1.default.createElement(text_1.Text, { color: text_1.Text.COLORS.DARK_BLUE, weight: text_1.Text.WEIGHTS.BOLD, text: cell.label.toUpperCase() })) : (cell.label)),
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('data-grid-cell', 'data-cell', {
                            'no-right-border': noRightBorder,
                        }) },
                        react_1.default.createElement(exports.DGDataCell, { value: cell.value }))));
            })));
        }))));
};
exports.DataGrid = DataGrid;
